import { VariableType } from 'json-to-graphql-query';

import { DataDateRange } from '@/interfaces/dataDateRange';
import { DateRange } from '@/interfaces/dateRange';
import { Decision } from '@/interfaces/decision';
import { DecisionDateRange } from '@/interfaces/decisionDateRange';
import { EntityResource } from './entity.resource';

/**
 * Resource decyzji
 *
 * @export
 * @class DecisionResource
 * @extends {EntityResource<Decision>}
 */
export class DecisionResource extends EntityResource<Decision> {
  public getFields = {
    id: true,
    name: true
  };

  public listFields = {
    id: true,
    name: true,
    number: true,
    data: true,
    startDate: true,
    endDate: true,
    document: {
      id: true,
      systemNumbers: true
    }
  };

  constructor() {
    super({
      entityName: 'decision'
    });
  }

  public getDates(
    documentId: string,
    statusId: string
  ): Promise<DateRange & { dateRanges: DecisionDateRange[]; dataDateRanges?: { [key: string]: DataDateRange[] } }> {
    const query = this.prepareOptions({
      query: {
        __variables: { id: 'Int!', statusId: 'Int!' },
        getDates: {
          __args: {
            id: new VariableType('id'),
            statusId: new VariableType('statusId')
          },
          startDate: true,
          endDate: true,
          dateRanges: {
            startDate: true,
            endDate: true,
            type: true
          }
        }
      }
    });
    return this.query({ query, variables: { id: documentId, statusId } }, 'getDates');
  }
}

export const decisionResource = new DecisionResource();
